import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AdvMessageService, FormValidationsService, LoginStatus, OwnValidators } from 'projects/shared/src/public-api';
import { AppAuthService } from '../../../kesher-shared/services/app-auth.service';
import { ActivatedRoute } from '@angular/router';
import { FormService, LocalizationService } from 'projects/shared/src/public-api';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ValidatorService } from 'shared/src/lib/validators/password/validator.service';

@Component({
  selector: 'new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {

  //when user just complete register (update details, not *new* user - happens when manager register him to his company and send him email to complete register)
  //user get mail with link to complete register, the link contains token that save in DB all user details
  loginByToken = false;
  token: string = null;
  newUserForm: FormGroup;

  @Output() verificationCodeSent: EventEmitter<any> = new EventEmitter();

  constructor(private formService: FormService, 
    private _appAuthService: AppAuthService, 
    private route: ActivatedRoute,
     private messageService: AdvMessageService,
     private formValidationsService: FormValidationsService,
     private localizationService : LocalizationService, 
     private recaptchaV3Service: ReCaptchaV3Service,
      private passwordValidatorService: ValidatorService
    ) { }

  // #region angular lyfecycle events
  ngOnInit(): void {
    this.initFormControls();
    this.route.queryParams.subscribe(params => {
      if (params.token) {
        this.loginByToken = true;
        this._appAuthService.getNewUserMailByToken(params.token).subscribe(res => {
          this.newUserForm.controls.Mail.patchValue(res.entity);
          this.newUserForm.controls['Mail'].disable();
          this.token = params.token;
        })
      }
      else
        this.loginByToken = false;
    })
  }
  // #endregion

  // #region public methods
  startRegistration() {
    if (this.newUserForm.valid) {
      let signupParams = this.formService.getFormValues(this.newUserForm);
      if (this.loginByToken)
        signupParams.token = this.token;

        this.recaptchaV3Service.execute('startRegistration')
        .subscribe((token: string) => {
          signupParams.captchaToken = token;
          this._appAuthService.signup(signupParams).subscribe(res => {
            if (!res.succeeded) {
              if (res.status == LoginStatus.UserMailExists)
                this.messageService.errorMessage("לא ניתן להרשם עם כתובת מייל זו")
              if (res.status == LoginStatus.UserPhoneExists)
                this.messageService.errorMessage("לא ניתן להרשם עם מספר טלפון זה")
              if (res.status == LoginStatus.RequiredVerification)
                this.messageService.errorMessage(this.localizationService.Translate('ERROR_MESSAGES.UNKNOWN_ERROR'))
            }
            else {
              if (res.status == LoginStatus.VerificationCodeSent) {
                this.verificationCodeSent.emit({ ...res, password: this.newUserForm.get("Password").value, mail: this.newUserForm.get("Mail").value });
              }
            }
          });
        });
    }
    else {
      this.formValidationsService.markFormGroupTouched(this.newUserForm);
    }
  }
  // #endregion


  // #region private methods
  private initFormControls() {
    this.newUserForm = new FormGroup({
      FirstName: new FormControl(''),
      LastName: new FormControl(''),
      Phone: new FormControl('', [Validators.required, Validators.minLength(7), Validators.maxLength(10), OwnValidators.validPhone]),
      Mail: new FormControl('', [Validators.required, Validators.email]),
      Password: new FormControl('', [Validators.required, Validators.maxLength(40), OwnValidators.correctPassword],[(control: FormControl) => this.passwordValidatorService.asyncCheckIfPasswordWeak(control)]),
      PasswordConfirm: new FormControl('', [Validators.required, Validators.maxLength(40), this.confirmPasswordMatch.bind(this)])
    });
  }

  private confirmPasswordMatch(control: FormControl) {
    if (this.newUserForm)
      return control.value == this.newUserForm?.get("Password")?.value ? null : { passwordMismatch: true };
    return null;
  }
  // #endregion

  onPasswordChanged() {
    this.newUserForm.controls.PasswordConfirm.updateValueAndValidity();
  }
}
